import React from 'react';
import { IIconProps } from './type';

const QuestionMarkOutline: React.FC<IIconProps> = ({
  UNSAFE_className,
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 17"
      fill="currentColor"
      className={UNSAFE_className || ''}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 15.5C11.866 15.5 15 12.366 15 8.5C15 4.63401 11.866 1.5 8 1.5C4.13401 1.5 1 4.63401 1 8.5C1 12.366 4.13401 15.5 8 15.5ZM8 16.5C12.4183 16.5 16 12.9183 16 8.5C16 4.08172 12.4183 0.5 8 0.5C3.58172 0.5 0 4.08172 0 8.5C0 12.9183 3.58172 16.5 8 16.5Z"
      />
      <path d="M7.088 10.596V10.392C7.088 10.112 7.116 9.872 7.172 9.672C7.236 9.464 7.352 9.252 7.52 9.036C7.688 8.812 7.928 8.548 8.24 8.244C8.456 8.028 8.624 7.832 8.744 7.656C8.872 7.472 8.936 7.252 8.936 6.996C8.936 6.668 8.848 6.42 8.672 6.252C8.504 6.076 8.256 5.988 7.928 5.988C7.552 5.988 7.264 6.08 7.064 6.264C6.872 6.448 6.732 6.74 6.644 7.14L5 6.96C5.096 6.24 5.388 5.652 5.876 5.196C6.364 4.732 7.076 4.5 8.012 4.5C8.892 4.5 9.568 4.704 10.04 5.112C10.512 5.52 10.748 6.06 10.748 6.732C10.748 7.172 10.652 7.556 10.46 7.884C10.276 8.212 10.016 8.528 9.68 8.832C9.416 9.072 9.212 9.28 9.068 9.456C8.932 9.624 8.836 9.788 8.78 9.948C8.732 10.1 8.708 10.272 8.708 10.464V10.596H7.088ZM8.756 11.424V13.212H7.028V11.424H8.756Z" />
    </svg>
  );
};

export default QuestionMarkOutline;
